import type { MessageKey } from '@simple-qa/shared';

import type { AccountAccessSnapshot } from '../lib/api';
import { TransportError } from '../lib/errors';

export type AccountAccessState =
  | { readonly status: 'idle' }
  | { readonly status: 'loading' }
  | { readonly status: 'ready'; readonly account: AccountAccessSnapshot }
  | { readonly status: 'error'; readonly messageKey: MessageKey };

export type ResolvedAccountAccessState = Extract<AccountAccessState, { readonly status: 'ready' | 'error' }>;

export const IDLE_ACCOUNT_ACCESS: AccountAccessState = Object.freeze({ status: 'idle' });
export const LOADING_ACCOUNT_ACCESS: AccountAccessState = Object.freeze({ status: 'loading' });

/** Resolve an account call without allowing server detail or an unknown exception onto the screen. */
export async function resolveAccountAccess(
  load: () => Promise<AccountAccessSnapshot>,
): Promise<ResolvedAccountAccessState> {
  try {
    return Object.freeze({ status: 'ready', account: await load() });
  } catch (error) {
    return Object.freeze({
      status: 'error',
      messageKey: error instanceof TransportError ? error.messageKey : ('error.internal' as const),
    });
  }
}
